var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-8"},[_c('h2',{staticClass:"mb-2 text-lg font-medium text-gray-900"},[_vm._v(_vm._s(_vm.heading))]),_c('div',{staticClass:"w-full grid sm:grid-cols-2 md:grid-cols-3 gap-3"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }